var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.172,
    height: 24.092,
    viewBox: "0 0 29.172 24.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "speedometer",
    d: "M28.172,14.08a13.953,13.953,0,0,1-2.844,8.484,1.1,1.1,0,0,1-1.755-1.328A11.883,11.883,0,1,0,2.2,14.08a11.769,11.769,0,0,0,2.4,7.156,1.1,1.1,0,0,1-1.755,1.328A14.079,14.079,0,0,1,14.086,0,14.075,14.075,0,0,1,28.172,14.08ZM21.059,7.452a1.1,1.1,0,0,1,0,1.556L17.472,12.6a3.851,3.851,0,1,1-1.556-1.556L19.5,7.452a1.1,1.1,0,0,1,1.556,0Zm-5.325,6.973a1.648,1.648,0,1,0-1.648,1.648A1.65,1.65,0,0,0,15.734,14.425Zm0,0",
    transform: "translate(0.5 0.5)",
    fill: "#c19444",
    stroke: "#707070",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.8279cd8492ef8174d484c59954401bc5.svg";
export { ForwardRef as ReactComponent };